// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "pc/css/" + ({"727":"lottery","757":"game","917":"agreement","942":"article"}[chunkId] || chunkId) + "." + {"6":"c52f7add","345":"cfa2b0a3","617":"c754c0bf","727":"87686776","757":"c1ff94a9","786":"cfa2b0a3","824":"66a345f0","858":"a89c02fe","871":"e9f1bb26","917":"1ae01145","942":"03820ef1"}[chunkId] + ".css";
};